import Box from "@mui/material/Box";
import React, { useState } from "react";
import { useEffect } from "react";
import { useInView } from "react-intersection-observer";

interface AnimationContentContainerProps {
  render: (loadedAnimation: boolean) => JSX.Element;
  customThreshold?: number;
  // Threshold to start animation
  animationCanReplay?: boolean;
}

//Animation controller compoent to detect whether componet has enter the screen and should start the animation, it control the children's animation through context
const AnimationController = ({
  render,
  customThreshold,
  animationCanReplay,
}: AnimationContentContainerProps) => {
  const [alreadyLoaded, setAlreadyLoaded] = useState(false);
  //ref is used to bind the actual component so that it can be monitored, inView dictates whether this component is inside the screen
  const [ref, inView] = useInView({
    threshold: customThreshold ?? 0.2,
  });

  useEffect(() => {
    //Animation will only run once
    if (animationCanReplay) {
      if (inView) {
        setAlreadyLoaded(true);
      } else {
        setAlreadyLoaded(false);
      }
    } else {
      if (!alreadyLoaded && inView) {
        setAlreadyLoaded(true);
      }
    }
  }, [inView]);

  return (
    <Box ref={ref}>
      <Box sx={{ width: "100%", position: "relative", overflow: "hidden" }}>
        {render(alreadyLoaded)}
      </Box>
    </Box>
  );
};

export default AnimationController;
